import React from 'react';
import { urlDeConectInstaller } from '../../data/ConfigData';
import './ModalDeConect.css';

const DC_RAW_FEATURES = [
  ['Timbrado de facturas', '11'],
  ['Timbrado de nómina 1.2', '11'],
  ['Timbrado de complemento de recepción de pago', '11'],
  ['Timbrado de complemento de impuestos locales', '11'],
  ['Generación de PDF', '11'],
  ['Integración de catálogos de productos y servicios del SAT', '11'],
  ['Integración de catálogos de unidad de medida del SAT', '11'],
  ['Servicio de cancelación', '11'],
  ['Memorización de unidades de medida del SAT', '01'],
  ['Memorización de claves de productos y servicios del SAT', '01'],
  ['Regeneración de XML timbrado', '01'],
  ['Regeneración de PDFs', '01'],
  ['Reporte en Excel de XMLs timbrados', '01']
];

const DC_FEATURES = DC_RAW_FEATURES.map((r, i) => ({
  name: r[0],
  bg: i % 2 ? '#FAF8F6' : '#ffffff',
  cells: r[1].split('').map((v) => ({
    yes: v === '1',
    no: v !== '1',
    label: v === '1' ? 'Sí' : 'No'
  }))
}));

const ModalDeConect = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="df-deconect-modal-overlay" role="dialog" aria-modal="true" aria-labelledby="deconect-titulo">
      <div className="df-deconect-modal-backdrop" onClick={onClose} aria-hidden="true" />

      <div className="df-deconect-modal-dialog">
        {/* Cabecera Oficial */}
        <div className="df-deconect-modal-header">
          <div className="df-deconect-modal-header-titles">
            <span className="df-deconect-modal-tag">DECONECT</span>
            <h2 id="deconect-titulo" className="df-deconect-modal-title">
              SICAI DeConect
            </h2>
          </div>

          <button
            type="button"
            className="df-deconect-modal-close-btn"
            onClick={onClose}
            aria-label="Cerrar modal"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
              <path d="M6 6l12 12M18 6L6 18" />
            </svg>
          </button>
        </div>

        {/* Cuerpo con Scroll */}
        <div className="df-deconect-modal-scroll">
          <p className="df-deconect-desc-p">
            SICAI DeConect es una herramienta que te permite conectarte al servicio de Digital Factura para el timbrado de tus comprobantes fiscales. Además, si no quieres cambiar o actualizar tu software de facturación, te permite convertir tus comprobantes fiscales de la versión 3.2 y 3.3 a la versión 4.0 para que no te quedes sin timbrar. Todo esto junto con las ventajas de la facturación electrónica soportada por Digital Factura, Proveedor Autorizado de Certificación No. 58354: tus comprobantes serán totalmente válidos y cumplirán con la ley vigente, y podrás agregar herramientas personalizadas que se ajusten a tus necesidades.
          </p>

          {/* Requerimientos Mínimos */}
          <div className="df-deconect-req-box">
            <h3 className="df-deconect-req-title">Requerimientos mínimos</h3>
            <p className="df-deconect-req-intro">
              El equipo donde instales SICAI DeConect deberá cumplir con los siguientes requisitos; de lo contrario, el software no podrá ejecutarse adecuadamente o no se instalará.
            </p>
            <ul className="df-deconect-req-list">
              <li>Sistemas compatibles: Windows 7 (necesario Service Pack 1), Windows 8, Windows 8.1 y Windows 10.</li>
              <li>Contar con las actualizaciones más recientes de tu sistema operativo para la compatibilidad del sistema.</li>
              <li>Una conexión estable a Internet.</li>
              <li>Microsoft .NET Framework 4.5.</li>
              <li>2 GB de memoria RAM o superior.</li>
              <li>Espacio en el disco duro de 10 GB o superior.</li>
              <li>Procesador de 1.2 GHz o superior (recomendable doble núcleo o superior).</li>
            </ul>
          </div>

          {/* Tabla Oficial de Características */}
          <div className="df-deconect-table-card">
            <div className="df-deconect-th-row">
              <div className="df-deconect-th-feat">Características</div>
              <div className="df-deconect-th-col">
                <span className="df-deconect-th-name">Estándar</span>
                <span className="df-deconect-th-price">Gratuito</span>
              </div>
              <div className="df-deconect-th-col">
                <span className="df-deconect-th-name">Pro</span>
                <span className="df-deconect-th-price">$4,499.00</span>
              </div>
            </div>

            {DC_FEATURES.map((ft, idx) => (
              <div
                key={idx}
                className="df-deconect-tb-row"
                style={{ backgroundColor: ft.bg }}
              >
                <div className="df-deconect-td-feat">{ft.name}</div>
                {ft.cells.map((c, cIdx) => (
                  <div key={cIdx} className="df-deconect-td-cell">
                    {c.yes ? (
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1E7B4F" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path d="M5 12.5l4.5 4.5L19 7.5" />
                      </svg>
                    ) : (
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9AA0AB" strokeWidth="2.6" strokeLinecap="round" aria-hidden="true">
                        <path d="M6 12h12" />
                      </svg>
                    )}
                    <span className="df-visually-hidden">{c.label}</span>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>

        {/* Pie Oficial del Modal */}
        <div className="df-deconect-modal-footer">
          <a
            href={urlDeConectInstaller}
            download=""
            className="df-deconect-btn-download"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 4v11M7 10l5 5 5-5M5 20h14" />
            </svg>
            Descarga ahora
          </a>
        </div>
      </div>
    </div>
  );
};

export default ModalDeConect;
